module.exports = __webpack_public_path__ + "components/country-flag/static/qa-87b7503256c363ee23386eb63b692e3e.svg";